import { SyosSelectionMode } from '../SyosConfig';
import { IPriceTypeSelectionHelper, IPriceTypeId } from './types';

class StandardPriceTypeSelectionHelper implements IPriceTypeSelectionHelper {
  mode: SyosSelectionMode = 'standard';

  selectionsRemaining: number = Infinity;

  #isSelectionComplete = false;

  #selectionCount = 0;

  totalSelectionCount = Infinity;

  canMakeAnotherSelection = true;

  get selectionCount() { return this.#selectionCount; }

  get isSelectionComplete() { return this.#isSelectionComplete; }

  public updateSelections(selections: number[]) {
    this.#selectionCount = selections.length;

    this.#isSelectionComplete = selections.length > 0;
  }

  getFilteredPriceTypes<T extends IPriceTypeId>(pricetypes: T[]): T[] {
    return pricetypes;
  }
}

export default StandardPriceTypeSelectionHelper;
